<template>
  <div class="shop-menu-fulfilment-wall wrapper">
    <div class="scroll no-scrollbar">
      <div v-if="showYesNo">
        <p class="subtitle header has-text-black">
          <span style="font-size: 1.2em">{{
            $t("menu.is-this-a-delivery-order")
          }}</span>
        </p>

        <div
          class="notification pulse has-text-success yes-no"
          @click="choose('delivery')"
        >
          <i class="fa fa-shipping-fast" />
          {{ $t("menu.yes-delivery") }}
          <i class="fa fa-chevron-right is-pulled-right" />
        </div>

        <div
          class="notification has-text-grey yes-no"
          style="margin-top: 20px; opacity: 0.5"
          @click="showYesNo = false"
        >
          <div class="x has-text-black">X</div>
          <i class="fa fa-shipping-fast has-text-danger" />
          {{ $t("menu.no-not-delivery") }}
          <i class="fa fa-chevron-right is-pulled-right" />
        </div>

        <div style="padding: 0 16px; color: grey">
          <i>
            {{ $t("menu.range-of-fulfilment") }}
          </i>
        </div>

        <!-- <div
          class="notification has-text-grey yes-no"
          style="margin-top: 60px; opacity: 0.5"
          @click="choose('skip')"
        >
          <i class="fa fa-shopping-basket has-text-grey" />
          {{ $t("menu.view-basket") }}
          <i
            class="fa fa-chevron-down is-pulled-right"
            style="margin-top: 6px"
          />
        </div> -->
      </div>

      <!-- Chose NOT delivery -->
      <div v-else>
        <p class="subtitle header has-text-black">
          <span>{{ $t("commerce.choose-fulfilment-method") }}</span>
        </p>

        <div
          v-if="hasDelivery"
          class="notification pulse"
          @click="choose('delivery')"
        >
          <p class="subtitle">
            <i class="fa fa-shipping-fast" />
            {{ $t("commerce.delivery") }}
          </p>
          <p>{{ $t("commerce.driver-will-bring-to-you") }}</p>
          <p class="hint">
            <i>* {{ $t("commerce.most-popular-choice") }}</i>
          </p>
          <a class="button is-fullwidth is-success">
            <i class="fa fa-shipping-fast" />
            {{ $t("commerce.deliver-my-order") }}
          </a>
        </div>

        <div
          v-if="hasTakeaway"
          class="notification"
          @click="preChoose('take-away')"
        >
          <p v-if="hasDelivery" class="has-text-danger not-delivery">
            *{{ $t("commerce.not-a-delivery") }}
          </p>
          <p class="subtitle">
            <i class="fa fa-walking" />
            {{ $t("commerce.take-away-explicit") }}
            <!-- Self-pickup / {{ $t("commerce.take-away") }} -->
          </p>
          <p>{{ $t("commerce.you-pickup-yourself") }}</p>
          <p class="hint">
            <i>{{ $t("commerce.aka-togo-carryout") }}</i>
          </p>

          <a class="button is-fullwidth is-grey">
            <i class="fa fa-walking" />
            {{ $t("commerce.ill-pickup-my-order") }}
          </a>
        </div>

        <div
          v-if="hasDinein"
          class="notification"
          @click="preChoose('dine-in')"
        >
          <p v-if="hasDelivery" class="has-text-danger not-delivery">
            *{{ $t("commerce.not-a-delivery") }}
          </p>
          <p class="subtitle">
            <i class="fa fa-users" />
            {{ $t("commerce.dine-in") }}
          </p>
          <p>{{ $t("commerce.you-eat-at-restaurant") }}</p>
          <p class="hint">
            <i>{{ $t("commerce.special-dine-in-promos") }}</i>
          </p>
          <a class="button is-fullwidth is-grey">
            <i class="fa fa-users" />
            {{ $t("commerce.ill-eat-at-the-shop") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShopMenuFulfilmentWall",
  props: {
    fulfilmentOptions: Array,
    legacyDelivery: Boolean,
  },
  data() {
    return {
      showYesNo: true,
    };
  },
  computed: {
    hasDinein() {
      if (!this.fulfilmentOptions.length) return true;
      return this.fulfilmentOptions.includes("dine-in");
    },
    hasTakeaway() {
      if (!this.fulfilmentOptions.length) return true;
      return this.fulfilmentOptions.includes("take-away");
    },
    hasDelivery() {
      if (!this.fulfilmentOptions || !this.fulfilmentOptions.length) {
        return this.legacyDelivery;
      }
      return this.fulfilmentOptions.includes("delivery");
    },
  },
  mounted() {
    if (!this.hasDelivery) this.showYesNo = false;
    if (this.hasDelivery && !this.hasDinein && !this.hasTakeaway) {
      console.log("ShopMenuFulfilmentWall only delivery");
      this.choose("delivery");
    }
  },
  methods: {
    doubleConfirmNotDelivery(fulfilmentType) {
      var red = this.bulmaColor("danger");
      var fulfilment = this.translateFulfilmentType(fulfilmentType);
      var title = `Please Confirm: <strong>${fulfilment}</strong>`;
      this.$swal({
        html: `<div style='text-align:left'>
        <div style='position: absolute; margin-top: -10px; margin-left: 2px; color: rgba(0, 0, 0, 0.7); font-size: 2em;'>X</div>
          <p style='font-size:1.2em; margin-bottom:12px'>
          <i class='fa fa-shipping-fast' style='color:${red}'></i>&nbsp;${title}
          </p>
          <p style='margin-bottom:10px'>You've selected Non-Delivery fulfilment.</p>
          <p style='margin-bottom:10px'>No delivery driver will be sent.</p>
          <p>You will go the shop yourself.</p>
          </div>`,
        showCancelButton: true,
        cancelButtonText: "Not Delivery",
        // cancelButtonColor: red,
        confirmButtonText: "Delivery",
        confirmButtonColor: this.bulmaColor("success"),
      }).then((val) => {
        if (val.dismiss === "cancel") this.choose(fulfilmentType);
        if (val.value) this.choose("delivery");
      });
    },
    preChoose(fulfilmentType) {
      this.choose(fulfilmentType);
      // skip the double confirm for non-delivery for now
      // if (this.hasDelivery && fulfilmentType !== "delivery") {
      //   this.doubleConfirmNotDelivery(fulfilmentType);
      // } else {
      //   this.choose(fulfilmentType);
      // }
    },
    choose(fulfilmentType) {
      if (fulfilmentType === "delivery" && !this.hasDelivery) {
        var msg = `Sorry, delivery is not available right now<br>Choose from the following options:`;
        this.errorToast(msg, "top", 20000);
        this.showYesNo = false;
        return;
      }
      if (fulfilmentType === "dine-in") {
        // select table / or I'll be there soon
      }
      this.$emit("choose", fulfilmentType);
    },
  },
};
</script>

<style scoped>
.wrapper {
  position: absolute;
  bottom: 0;
  height: calc(100vh - 150px);
  width: 100vw;
  max-width: 700px;
  overflow: hidden;
  background-color: white;
  /* z-index: 1102; */
  z-index: 3;
  text-align: left;
}
.scroll {
  height: 100%;
  overflow: scroll;
  padding-bottom: 120px;
}
.header {
  padding: 12px;
  padding-bottom: 4px;
  margin-bottom: 4px;
  font-size: 1.1em;
  font-weight: 500;
  opacity: 0.5;
}
.button.is-grey {
  background-color: hsl(0, 0%, 96%);
}
.notification {
  margin: 12px;
  padding: 12px;
  border: 1px solid #ddd;
  background-color: white;
}
.notification p {
  margin-bottom: 8px;
}
.fa {
  margin-right: 6px;
}
.hint {
  font-weight: 500;
  font-size: 0.8em;
}
@keyframes shadow-pulse-gold {
  0% {
    box-shadow: 0 0 0 0px rgba(247, 211, 8, 1);
  }
  100% {
    box-shadow: 0 0 0 8px rgba(247, 211, 8, 0.6);
  }
}
.pulse {
  animation: shadow-pulse-gold 1s infinite;
}
.yes-no {
  font-size: 1.5em;
  font-weight: 500;
}
.x {
  position: absolute;
  top: -2px;
  margin-left: 0px;
  color: rgba(0, 0, 0, 0.4);
  font-size: 1.8em;
}
.fa-chevron-right {
  margin-top: 6px;
}
.not-delivery {
  text-transform: uppercase;
  font-size: 8pt;
  font-weight: 550;
  height: 0;
  margin-top: -6px;
  text-align: right;
}
</style>